
export function convertECPostData (customItem) {
  const ecJsonData = {
    'customid': customItem['customID'],
    'ggcd': '',
    'gcd': '',
    'basegoodsprice': customItem['price'], // baseItem = trueのパーツ金額
    'customimage': customItem['customImage'][0]['filename'],
    'customcontent1': 'なし',
    'customcontent2': 'なし',
    'customprice1': 0,
    'customprice2': 0
  }

  const parts = customItem['parts']
  let customcontent1 = '' // 部材（ワッペン、本体カラー等）
  let customcontent2 = '' // 加工（刺繍・刻印文字）
  let customprice1 = 0 // 部材費合計
  let customprice2 = 0 // 加工費合計

  parts.forEach(element => {
    if (element['baseItem'] === true) {
      ecJsonData['ggcd'] = element['ggcd']
      ecJsonData['gcd'] = element['gcd']
      ecJsonData['basegoodsprice'] = element['price']

      // 本体パーツは部材に所属するので部材に追加（価格は入れない)
      // customcontent1 += element['label'] + ':'
      // customcontent1 += element['name'] + ':'
      // customcontent1 += 0 + ';'
    }

    // 本体パーツを含めた部材・部材費設定（本体パーツの価格は含めない）
    if (element['type'] !== 'type3') {
      customcontent1 += element['label'] + ':'
      customcontent1 += element['name'] + ':'

      if (element['baseItem'] !== true) {
        customcontent1 += element['price'] + ';'
        customprice1 += element['price']
      } else {
        customcontent1 += 0 + ';'
      }
    }

    // 本体パーツ以外の加工・加工費設定（刺繍・刻印）
    if (element['baseItem'] === false && element['type'] === 'type3') {
      customcontent2 += element['label'] + ':'
      customcontent2 += element['name']
      customcontent2 += ' ' + element['embroidery']['inputText'] + ':' // 入力文字
      customcontent2 += element['price'] + ';'

      customprice2 += element['price']
    }
  })

  ecJsonData['customcontent1'] = (customcontent1 !== '') ? customcontent1 : 'なし'
  ecJsonData['customprice1'] = customprice1

  ecJsonData['customcontent2'] = (customcontent2 !== '') ? customcontent2 : 'なし'
  ecJsonData['customprice2'] = customprice2

  return ecJsonData
}



// WEBPACK FOOTER //
// ./src/modules/ECData.js